import { COMMON_URLS } from '@insurancemenu/imenu-components-lib/dist/utils/urls';

export function buildPdfLink(id: string): string {
  return `https://${COMMON_URLS.api}/pdf/Prod/download/${id}`;
}
